var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_3502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1771 6.40385C10.1334 6.5582 9.92299 6.5582 9.87934 6.40385C9.50982 5.10046 8.48243 4.07619 7.18217 3.70512C7.02782 3.66146 7.02782 3.45257 7.18217 3.40891C8.48555 3.03784 9.50982 2.01197 9.87934 0.71018C9.92299 0.555835 10.1334 0.555835 10.1771 0.71018C10.5466 2.01357 11.574 3.03784 12.8743 3.40891C13.0286 3.45257 13.0286 3.66146 12.8743 3.70512C11.574 4.07619 10.5466 5.10202 10.1771 6.40385Z",
    fill: "#888B8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5165 9.34456C14.5406 9.62208 13.7704 10.3922 13.4929 11.3698C13.4601 11.4851 13.3027 11.4851 13.2715 11.3698C12.994 10.3922 12.2238 9.62208 11.2479 9.34456C11.1309 9.31339 11.1309 9.15592 11.2479 9.12319C12.2238 8.84723 12.994 8.07703 13.2715 7.09954C13.3027 6.98261 13.4601 6.98261 13.4929 7.09954C13.7704 8.07703 14.5406 8.84723 15.5165 9.12319C15.6335 9.15592 15.6335 9.31027 15.5165 9.34456Z",
    fill: "#888B8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11356 11.1854C7.16318 11.7405 5.62284 13.2777 5.06936 15.2312C5.00233 15.4635 4.68896 15.4635 4.62193 15.2312C4.06846 13.2792 2.53122 11.7405 0.577737 11.1854C0.343879 11.1184 0.343879 10.8066 0.577737 10.7396C2.52812 10.1861 4.06846 8.64885 4.62193 6.69535C4.68896 6.46149 5.00233 6.46149 5.06936 6.69535C5.62284 8.64577 7.16006 10.1861 9.11356 10.7396C9.34742 10.8066 9.34742 11.1184 9.11356 11.1854Z",
    fill: "#888B8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_3502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.688f7aaedbce6cbb4f8a8c45d626f60b.svg";
export { ForwardRef as ReactComponent };